import * as a from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Package.es.js";
const e = a.forwardRef((o, c) => /* @__PURE__ */ a.createElement(r, { ref: c, ...o, weights: t }));
e.displayName = "PackageIcon";
const n = e;
export {
  n as Package,
  e as PackageIcon
};
